import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UrlBuilderService } from '@common/services/url-builder.service';
import { BehaviorSubject, map, take, tap } from 'rxjs';
import { CancellableActivityItem } from '../cancel-activities.types';
import {ToastrService} from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class CancelActivitiesService {

  private readonly activitiesSubject = new BehaviorSubject<CancellableActivityItem[]>([]);

  get activities$() {
    return this.activitiesSubject.asObservable();
  }

  constructor(
    private readonly http: HttpClient,
    private readonly urlBuilder: UrlBuilderService,
    private messageService: ToastrService) {}

  refreshActivities() {
    const u = this.urlBuilder.getUrl('cancellable-activities');
    const fetch = this.http.get<CancellableActivityItem[]>(u).pipe(
      take(1),
      map(activities => activities.map( activity => ({ ...activity, DateCreated: new Date(activity.DateCreated)} as CancellableActivityItem))),
      tap(activities => this.activitiesSubject.next(activities))
    );
    return fetch;
  }

  cancelActivities(formDataIds: number[]) {
    const u = this.urlBuilder.getUrl('cancel-activities');
    return this.http.post(u, formDataIds)
      .pipe(
        tap(() => {
          this.messageService.success('Selected forms have been cancelled.');
        }),
      );
  }

}
